import PropTypes from 'prop-types';
import { OrbitProgress } from 'react-loading-indicators';

import plusIconGrey from '../../../../assets/images/plusIcon_grey.svg';
import plusIconWhite from '../../../../assets/images/plusIcon_white.svg';
import styles from './styles/styles.module.css';

function RedButton({
  text,
  onClick,
  plusLeft,
  plusRight,
  disabled,
  width,
  height,
  smallText,
  loading,
}) {
  return (
    <button
      className={`${styles.redButton} ${smallText ? styles.redButton_smallText : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        width: width || '100%',
        height: height || 'auto',
      }}
    >
      {plusLeft && (
        <img
          className={styles.plusIcon}
          src={!disabled ? plusIconWhite : plusIconGrey}
          alt="иконка плюс"
        />
      )}
      {loading ? (
        <OrbitProgress
          dense
          color="#2DB270"
          style={{ fontSize: '8px', display: 'flex' }}
          size="small"
          text=""
          textColor=""
        />
      ) : (
        text
      )}
      {plusRight && (
        <img
          className={styles.plusIcon}
          src={!disabled ? plusIconWhite : plusIconGrey}
          alt="иконка плюс"
        />
      )}
    </button>
  );
}

export default RedButton;

RedButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  plusLeft: PropTypes.bool,
  plusRight: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  smallText: PropTypes.bool,
  loading: PropTypes.bool,
};
